// extracted by mini-css-extract-plugin
export default {"media":"yh0ek","media__content":"id35b"};